import { Group, Property, TransformedProperties } from 'utils/types/ankiro';

export function transformGroupedResults(groupedResults: Group[] | undefined): { [key: string]: number } {
  const transformed: { [key: string]: number } = {};

  groupedResults?.forEach((result) => {
    const { Value, Count } = result;
    transformed[Value] = Count;
  });

  return transformed;
}

export const transformedProperties = (item: Property[]) =>
  item.reduce<TransformedProperties>((result, item) => {
    result[item.Name] = item.Value;
    return result;
  }, {} as TransformedProperties);
